import type { IAPI } from '../../apiResponse';
import type { IRequestOptions } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IBrowseCollectionsData } from '../browseCollections';
import { browseCollectionsResponseSchema } from '../browseCollections';

export async function browseCollectionsV3Api(options?: IRequestOptions) {
  return getRequest<IAPI<IBrowseCollectionsData>>({
    path: '/collections/browse/v3',
    schema: browseCollectionsResponseSchema,
    options,
  });
}
